module.exports = __webpack_public_path__ + "img/skill-4.7fff74bb.png";